import api from './api';

const statisticsService = {
  // Get all statistics in one call
  getAllStatistics: async (startDate, endDate) => {
    try {
      const response = await api.get('/statistics', {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching statistics:', error);
      throw error;
    }
  },

  // Individual statistics endpoints (for backward compatibility if needed)
  getInventoryStatistics: async () => {
    try {
      const response = await api.get('/statistics/inventory');
      return response.data;
    } catch (error) {
      console.error('Error fetching inventory statistics:', error);
      throw error;
    }
  },

  getFinancialStatistics: async (startDate, endDate) => {
    try {
      const response = await api.get('/statistics/financial', {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching financial statistics:', error);
      throw error;
    }
  },

  getCashFlowStatistics: async (startDate, endDate) => {
    try {
      const response = await api.get('/statistics/cashflow', {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching cash flow statistics:', error);
      throw error;
    }
  },

  getIncomeStatementStatistics: async (startDate, endDate) => {
    try {
      const response = await api.get('/statistics/income-statement', {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching income statement statistics:', error);
      throw error;
    }
  },

  getBalanceSheetStatistics: async (startDate, endDate) => {
    try {
      const response = await api.get('/statistics/balance-sheet', {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching balance sheet statistics:', error);
      throw error;
    }
  }
};

export { statisticsService };
